module.exports = __webpack_public_path__ + "media/application/assets/fonts/BebasNeue-Regular-bc1037b6180b03cd2af42a18b60999cf.woff2";